import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'

/*Rutas Admin */
import DashBoardAdmin from '../components/Admin/DashBoardAdmin';
import Areas from '../components/Admin/Areas';
import Usuarios from '../components/Admin/Usuarios';
import UsuariosInactivos from '../components/Admin/UsuariosInactivos';
import Aplicaciones from '../components/Admin/Aplicaciones';
import Permisos from '../components/Admin/Permisos';
import Cargos from '../components/Admin/Cargos';
import Puntos from '../components/Admin/Puntos';
import ConfigP from '../components/Admin/ConfiguracionPuntos';

/* Rutas Usuario*/
import DashBoardUser from '../components/Usuarios/DashBoardUser';
import InicioU from '../components/Usuarios/Inicio';
import Perfil from '../components/Usuarios/Perfil';
import Panico from '../components/Usuarios/Panico';

/* Rutas Callcenter-Admin */
import DashBoardAdminCallcenter from '../components/Callcenter/Admin/DashBoardAdminCallcenter';
import AreasCallcenter from '../components/Callcenter/Admin/Areas';
import RequerimientosCallcenter from '../components/Callcenter/Admin/Requerimientos';
import Frases from '../components/Callcenter/Admin/Frases';

/* Rutas Callcenter-Asesor */
import DashBoardAsesor from '../components/Callcenter/Asesor/DashBoardAsesor';
import Asesor from '../components/Callcenter/Asesor/Asesor';
import NuevoIncidente from '../components/Callcenter/Asesor/NuevoIncidente';
import ConsultarIncidente from '../components/Callcenter/Asesor/ConsultarIncidente';
import Chat from '../components/Callcenter/Asesor/Chat';
import PanelAdminBot from '../components/Callcenter/Asesor/PanelAdminBot/PanelAdminBot';

/* Rutas Callcenter-Especialistas */
import DashBoardEspecialista from '../components/Callcenter/Especialista/DashBoardEspecialista';
import InicioCallcenterEspecialista from '../components/Callcenter/Especialista/Inicio';
import PendientesEspecialista from '../components/Callcenter/Especialista/Pendientes';
import CerradosCallcenter from '../components/Callcenter/Especialista/Cerrados';
import AsignadosCallcenter from '../components/Callcenter/Especialista/Asignados';
import SuspendidosCallcenter from '../components/Callcenter/Especialista/Suspendidos';
import Todos from '../components/Callcenter/Especialista/Todos';

/* Rutas Callcenter-Reportes */
import DashBoardReportes from '../components/Callcenter/Reportes/DashBoardReportes';
import InicioCallcenterReportes from '../components/Callcenter/Reportes/Inicio';
import Fecha from '../components/Callcenter/Reportes/Fecha';
import Fechas from '../components/Callcenter/Reportes/Fechas';
import InicioEstadisticasReportes from '../components/Callcenter/Reportes/Inicio_Estadisticas.vue';
import ReporteGeneral from '../components/Callcenter/Reportes/Reportegeneral.vue';

//Ruta Callcenter-CasosDesenrolamiento
import uploadCase from '../components/Callcenter/FormCasos/RegistroHuella.vue';
import DashboardFormCase from '../components/Callcenter/FormCasos/DashboardFormCase.vue';

/* Rutas para zona */
import ZonasDashboard from '../components/Zonas/DashboardZonas';
import ZonasPuntos from '../components/Zonas/Puntos';
import Asignacion from '../components/Zonas/Asignacion';

/* Rutas Gestion Entradas/Salidas */
import DashBoard_entradas_salidas from '../components/Gestion_entradas_salidas/Admin/DashBoardAdmin.vue';
import Registros_entradas_salidas from '../components/Gestion_entradas_salidas/Admin/Historial.vue';
import Historial_entradas_salidas from '../components/Gestion_entradas_salidas/Admin/Historial.vue';
import Permisos_entradas_salidas from '../components/Gestion_entradas_salidas/Admin/Permisos.vue';

//######################################FIN TURNO CON BIOMETRIA################################
/*==============================================Administrativo============================================*/
import DashBoardVisitasNAdminT from '../components/FinTurno/Admin/DashboardVisitasNAdmin.vue';
import RegistroHuellaT from '../components/FinTurno/Admin/RegistroHuella.vue';
/*==============================================usuario===================================================*/
import DashboardVisitasNuserT from '../components/FinTurno/Usuario/DashboardVisitasNuser.vue';
import RegistraVisitaT from '../components/FinTurno/Usuario/RegistraVisita.vue';
/*==============================================usuario2===================================================*/
import DashboardVisitasNuserT2 from '../components/FinTurno/Usuario2/DashboardVisitasNuser.vue';
import RegistraVisitaT2 from '../components/FinTurno/Usuario2/RegistraVisita.vue';
/*==============================================Coordinacion==============================================*/
import DashboardVisitasNcoorT from '../components/FinTurno/coordinacion/DashboardVisitasNcoor.vue';
import ReporteVisitaBT from '../components/FinTurno/coordinacion/ReporteVisitaB.vue';
//######################################(fin) FIN TURNO CON BIOMETRIA####################################

/* Rutas para Premios */
import DashBoardAdminPremios from '../components/Premios/Admin/DashboardAdmin.vue';
import DashBoardUserPremios from '../components/Premios/Usuario/DashboardUser.vue';
import FileUploadPremios from '../components/Premios/Admin/FileUpload.vue';
import ReceiptPrinterPremios from '../components/Premios/Usuario/ReceiptPrinter.vue';
import HistorialConsultasPremios from '../components/Premios/Admin/HistorialConsultas.vue';

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  //administrador
  {
    path: '/Admin',
    component: DashBoardAdmin,
    meta: {
      requiresAuth: false,
      roles:[9]
    },
    children: [
      {
        path: "/",
        component: Usuarios
      },
      {
        path: "Areas",
        component: Areas
      },
      {
        path: "Cargos",
        component: Cargos
      },
      {
        path: "Usuarios",
        component: Usuarios
      },
      {
        path: "Aplicaciones",
        component: Aplicaciones
      },
      {
        path: "Permisos",
        component: Permisos
      },
      {
        path: "Puntos",
        component: Puntos
      },
      {
        path: "ConfiguracionPuntos",
        component: ConfigP
      },
      {
      path: "UsuariosInactivos",
      component: UsuariosInactivos
      },
    ]
  },
  //Usuario
  {
    path: '/User',
    component: DashBoardUser,
    meta: {
      requiresAuth: false,
      roles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90]
    },
    children: [
      {
        path: "/",
        component: InicioU
      },
      {
        path: "Inicio",
        component: InicioU,
        name: 'UserInicio'
      },
      {
        path: "Perfil",
        component: Perfil
      },
      {
        path: "Panico",
        component: Panico
      }
    ]
  },
  //Zonas
  {
    path: '/Zonas',
    component: ZonasDashboard,
    meta: {
      requiresAuth: false,
      roles:[19]
    },
    children: [
      {
        path: "/",
        component: ZonasPuntos
      },
      {
        path: "Puntos",
        component: ZonasPuntos
      },
      {
        path: "AsignacionZonas",
        component: Asignacion
      }
    ]
  },
  //Callcenter-Admin
  {
    path: '/Callcenter/Admin',
    component: DashBoardAdminCallcenter,
    meta: {
      requiresAuth: false,
      roles:[8]
    },
    children: [
      {
        path: "Areas",
        component: AreasCallcenter
      },
      {
        path: "Requerimientos",
        component: RequerimientosCallcenter
      },
    ]
  },
  //Callcenter-Asesor
  {
    path: '/Callcenter/Asesor',
    component: DashBoardAsesor,
    meta: {
      requiresAuth: false,
      roles: []
    },
    children: [
      {
        path: "/",
        component: NuevoIncidente
      },
      {
        path: "Inicio",
        component: Asesor
      },
      {
        path: "NuevoIncidente",
        component: NuevoIncidente
      },
      {
        path: "ConsultarIncidente",
        component: ConsultarIncidente
      },
      {
        path: "Chat",
        component: Chat
      },
      {
        path: "PanelBot",
        component: PanelAdminBot,
        meta: {
          requiresAuth: true,
          roles: [],
          restrictedIdUsuario: 1 // Solo el usuario con idUsuario = 1 puede acceder
        }
      },
    ]
  },
  //Callcenter-Especialista
  {
    path: '/Callcenter/Especialista',
    component: DashBoardEspecialista,
    meta: {
      requiresAuth: false,
      roles: []
    },
    children: [
      {
        path: "",
        component: Todos
      },
      {
        path: "Inicio",
        component: Todos
      },
      {
        path: "Todos",
        component: Todos
      },
      {
        path: "ConsultarIncidente",
        component: ConsultarIncidente
      },
      {
        path: "Chat",
        component: Chat
      },
      {
        path: "Pendientes",
        component: PendientesEspecialista
      },
      {
        path: "Cerrados",
        component: CerradosCallcenter
      },
      {
        path: "Asignados",
        component: AsignadosCallcenter
      },
      {
        path: "Suspendidos",
        component: SuspendidosCallcenter
      },
    ]
  },
  //Callcenter-Reportes
  {
    path: '/Callcenter/Reportes',
    component: DashBoardReportes,
    meta: {
      requiresAuth: false,
      roles: []
    },
    children: [
      {
        path: "",
        component: InicioEstadisticasReportes
      },
      {
        path: "Inicio",
        component: InicioEstadisticasReportes
      },
      {
        path: "Fecha",
        component: Fecha
      },
      {
        path: "Fechas",
        component: Fechas
      },
    {
          path: "General",
          component: ReporteGeneral,
          meta: {
            roles: [9] // Solo Control Interno puede ver este reporte
          }
        },
      ]
    },
  //Callcenter-CasosDesenrolamiento
  {
    path: '/Callcenter/FormCasos',
    component: DashboardFormCase,
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: "",
        component: uploadCase
      },
      {
        path: "Inicio",
        component: uploadCase
      },
    ]
  },
  {
    path: '/Gestion-entradas-salidas/Admin/',
    component: DashBoard_entradas_salidas,
    meta: {
      requiresAuth: false,
      roles: [66,59,9]
    },
    children: [
      {
        path: "/",
        component: Registros_entradas_salidas,
      },
      {
        path: "Registros",
        component: Registros_entradas_salidas,
      },
      {
        path: "Historial",
        component: Historial_entradas_salidas,
      },
      {
        path: "Permisos",
        component: Permisos_entradas_salidas,
      }
    ]
  },
  {
    path: '/FinTurno/Usuario',
    component: DashboardVisitasNuserT,
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: "",
        component: RegistraVisitaT
      },
      {
        path: "RegistraVisita",
        component: RegistraVisitaT
      }
      
    ]
  },
  {
    path: '/FinTurno/Usuario2',
    component: DashboardVisitasNuserT2,
    meta: {
      requiresAuth: false
    },
    children: [
      {
        path: "",
        component: RegistraVisitaT2
      },
      {
        path: "RegistraVisita",
        component: RegistraVisitaT2
      }
      
    ]
  },
  {
    path: '/FinTurno/coordinacion',
    component: DashboardVisitasNcoorT,
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: "",
        component: ReporteVisitaBT
      },
      {
        path: "inicio",
        component: ReporteVisitaBT
      }    
    ]
  },
  //Premios
  {
    path: '/Premios/Admin',
    component: DashBoardAdminPremios,
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: "",
        component: FileUploadPremios
      },
      {
        path: "FileUpload",
        component: FileUploadPremios
      },
      {
        path: "Historial",
        component: HistorialConsultasPremios
      }
    ]
  },
  {
    path: '/Premios/Usuario',
    component: DashBoardUserPremios,
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: "",
        component: ReceiptPrinterPremios
      },
      {
        path: "ReceiptPrinter",
        component: ReceiptPrinterPremios
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 🟢 NUEVO GUARD: Limpiar sesión 
router.beforeEach((to, from, next) => {
  // Lista de todas las rutas protegidas que requieren autenticación
  const rutasProtegidas = [
    '/Admin',
    '/Usuarios',
    '/Zonas',
    '/Callcenter/Admin',
    '/Callcenter/Asesor',
    '/Callcenter/Especialista',
    '/Callcenter/Reportes',
    '/Callcenter/FormCasos',
    '/Gestion-entradas-salidas/Admin',
    '/GestionIps',
    '/FinTurno/Admin',
    '/FinTurno/Usuario',
    '/FinTurno/Usuario2',
    '/FinTurno/coordinacion'
  ];

  // Verificar si viene de una ruta protegida y va al login
  const vieneDeRutaProtegida = rutasProtegidas.some(ruta => from.path.startsWith(ruta));
  const vaALogin = to.path === '/' || to.path === '/login';

  if (vieneDeRutaProtegida && vaALogin) {
    localStorage.clear();
    sessionStorage.clear();
  }

  next();
});

router.beforeEach((to, from, next) => {
  if (to.name === 'Login' && localStorage.getItem("id") != null) {
    router.push('/User/Inicio')
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {

    if (localStorage.getItem("id") != null) {
      next();
    } else {
      next({ name: "Login" });
    }
  } else {
    next();
  }
});
/***
 * Proteger Rutas
 */
router.beforeEach((to, from, next) => {
  const idRol = parseInt(localStorage.getItem('idCargo'), 10); // Obtener idRol como número
  const rol = localStorage.getItem('rol');
  const idUsuario = parseInt(localStorage.getItem('id'), 10); // Obtener idUsuario
  
  const autorizacion = to.matched.some(record => record.meta.requiresAuth); // Verificar si la ruta requiere autenticación

  if (autorizacion) {
    if (!idRol) {
      next('/'); // Redirigir al login si no está autenticado
    } else {
      // 🆕 Verificar restricción de idUsuario específico
      const rutaRestringida = to.matched.some(record => record.meta.restrictedIdUsuario);
      if (rutaRestringida) {
        const idUsuarioPermitido = to.matched.find(record => record.meta.restrictedIdUsuario)?.meta.restrictedIdUsuario;
        
        if (isNaN(idUsuario) || idUsuario !== idUsuarioPermitido) {
          if (isNaN(idUsuario)) {
            router.push('/'); // Redirigir al login si no hay ID válido
          } else {
            router.go(-1); // Navegar a la página anterior si no tiene permisos
          }
          return;
        } else {
          next();
          return;
        }
      }
      
      if (rol == "ADMINISTRADOR") {
        next(); // Permitir acceso a todas las rutas si es Administrador
      } else {
        // Verificar si el idRol está dentro de los roles permitidos para esta ruta
        const rolesPermitidos = to.matched.some(record => {
          return record.meta.roles && Array.isArray(record.meta.roles) && record.meta.roles.includes(idRol);
        });

        if (rolesPermitidos) {
          next(); // Permitir acceso si el idRol está permitido
        } else {
          router.go(-1); // Navegar a la página anterior en el historial sin mostrar mensaje
        }
      }
    }
  } else {
    next(); // Permitir acceso si no requiere autenticación
  }
});
export default router